import { addRoute } from "../shared/router.js";
import dynamicColors from "./page.vue";

addRoute("/dynamic-colors", dynamicColors);
